export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40ef24488f93a617c0aa53dea517c424c6c09cd5cd&name=revalidateCommunity!'